import { AloftPrice } from '@aloft/toolkit-shared';
import { Flex } from '@aloft/toolkit-sui';

import { selectImprovementsCostDisplay } from '../../../redux/features/selectors/selectImprovementsCost.ts';
import { selectCostNewDisplay } from '../../../redux/features/selectors/selectCostNew.ts';
import {
  selectExternalDepreciation,
  selectFunctionalDepreciation,
  selectPhysicalDepreciation,
} from '../../../redux/features/selectors/depreciationSelectors.ts';
import { useAppSelector } from '../../../redux/hooks.ts';
import { RootState } from '../../../redux/types.ts';
import { ContentBlock } from '../../../components/Analysis/ColumnComponents/ContentBlock.tsx';
import { DetailLineWithValue } from '../../../components/Analysis/ColumnComponents/DetailLineWithValue.tsx';
import { TotalLine } from '../../../components/Analysis/ColumnComponents/TotalLine.tsx';
import { PLACEHOLDER } from '../../analysis/consts.ts';

export const ImprovementsTotal = ({ id }: { id: string }) => {
  const { improvementsCost, costNew, physical, functional, external } = useAppSelector((state: RootState) => ({
    improvementsCost: selectImprovementsCostDisplay(state, id),
    costNew: selectCostNewDisplay(state, id),
    physical: selectPhysicalDepreciation(state, id),
    functional: selectFunctionalDepreciation(state, id),
    external: selectExternalDepreciation(state, id),
  }));

  const totalDepreciation =
    physical?.add(functional ?? AloftPrice.zero).add(external ?? AloftPrice.zero).roundToDollarLike().toString(true) ??
    undefined;

  return (
    <ContentBlock>
      <TotalLine label="Improvements" value={improvementsCost ?? PLACEHOLDER} />
      <Flex flexDirection="column" marginTop="0.5rem" gap="0.25rem">
        <DetailLineWithValue text="Cost New" value={costNew ?? 'N/A'} textColor="textTertiary" />
        <DetailLineWithValue
          text="Total Depreciation"
          value={totalDepreciation ?? 'N/A'}
          textColor="textTertiary"
        />
      </Flex>
    </ContentBlock>
  );
};
